import { useEffect, useState } from 'react'

import { viewport } from '@/Shared/domain'
import { useUI, useWindowSize } from '@/Shared/ui/navigation'

interface SidebarState {
  hover: boolean
  handleMouseEnter: () => void
  handleMouseLeave: () => void
}

export const useSidebar = (): SidebarState => {
  const [hover, setHover] = useState<boolean>(false)
  const { closeSidebar, openSidebar } = useUI()
  const { width } = useWindowSize()

  const handleMouseEnter = (): void | null =>
    width < viewport.desktop ? null : setHover(true)

  const handleMouseLeave = (): void | null =>
    width < viewport.desktop ? null : setHover(false)

  const setInitialSidebarState = (): void => {
    if (width < viewport.desktop) {
      closeSidebar()
    } else {
      openSidebar()
    }
  }

  useEffect(() => {
    setInitialSidebarState()
  }, [width])

  return {
    hover,
    handleMouseEnter,
    handleMouseLeave,
  }
}
